import React, { useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { Slider } from "primereact/slider";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import PropTypes from "prop-types";
import {  Link } from "react-router-dom";


import "./Search.scss";

// PropTypes validation
Search.propTypes = {
  options: PropTypes.array.isRequired,
  config: PropTypes.any.isRequired,
  setConfig: PropTypes.any.isRequired,
  setShowSettings: PropTypes.any.isRequired,
};

export default function Search({ options, config, setConfig, setShowSettings }) {
  const [form, setForm] = useState(config);
  const updateConfig = (field, value) => {
    const configValue = JSON.parse(JSON.stringify(form));
    configValue[field] = value;
    setForm(configValue);
  };

  const save = () => {
    
    setConfig(form);
    
    setShowSettings(false);
  };

  return (
    <div className="search-header">
      <div className="form-group">
        <label>Project Name </label>
        <MultiSelect
          value={form.projectNames}
          onChange={(e) => updateConfig("projectNames", e.value)}
          options={options}
          placeholder="Select Project"
          maxSelectedLabels={3}
        />
      </div>
      <div className="form-group">
        <label>Temperature </label>
        <div className="slider-form">
          <Slider
            value={form.temperature}
            onChange={(e) => updateConfig("temperature", e.value)}
            min={0}
            max={100}
          />
          <InputNumber value={form.temperature / 100} disabled={true} />
        </div>
      </div>
      <div className="form-group">
        <label>Top N Results </label>
        <div className="slider-form">
          <Slider
            value={form.result}
            onChange={(e) => updateConfig("result", e.value)}
            min={0}
            max={20}
          />
          <InputNumber value={form.result} disabled={true} />
        </div>
      </div>
      <div className="stream form-group">
        <label>Stream </label>
        <InputSwitch
          checked={form.isStream}
          onChange={(e) => updateConfig("isStream", e.value)}
        />
         <label>Cache</label>
        <InputSwitch
          checked={form.cache}
          onChange={(e) => updateConfig("cache", e.value)}
        />
    
      </div>
      <div className="save">
        <Button
          label="Close"
          severity="secondary"
          outlined
          onClick={() => setShowSettings(false)}
        />
        <Button label="Save" onClick={() => save()} />
        <Link to="/actions">
        <Button label="Actions" onClick={() => save()} />
        </Link> 
      </div>
    </div>
  );
}
